import React, { useEffect, useRef, useState } from 'react';
import { Pause, Play } from 'lucide-react';
import { useLocale } from '../../i18n/I18n';

export default function ServiceMedia({ visual }) {
  const { t } = useLocale();
  const container = useRef(null), player = useRef(null);
  const [visible, setVisible] = useState(false);
  const [playing, setPlaying] = useState(true);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false); setPlaying(true);
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { threshold: .15 }) : null;
    if (observer) observer.observe(container.current); else setVisible(true);
    return () => observer?.disconnect();
  }, [visual.poster]);
  useEffect(() => {
    const video = player.current;
    if (!video) return;
    if (visible && playing && !document.hidden) video.play()?.catch(() => setPlaying(false)); else video.pause();
    const onVisibility = () => { if (document.hidden) video.pause(); else if (visible && playing) video.play()?.catch(() => setPlaying(false)); };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [visible, playing, visual.poster]);
  return <figure ref={container} className="bz-service-media">
    <img src={visual.poster} alt={t(visual.alt)} width={1672} height={941} fetchPriority="high"/>
    {visual.video && !failed && <video ref={player} src={visible ? visual.video : undefined} poster={visual.poster} autoPlay={playing && visible} muted loop playsInline preload="none" tabIndex={-1} aria-hidden="true" onError={() => setFailed(true)}/>}
    <figcaption><visual.icon size={18} aria-hidden="true"/><span>{t('Tecnología al servicio de tu negocio.')}</span></figcaption>
    {visual.video && !failed && <button className="bz-service-media-toggle" type="button" aria-label={t(playing ? 'Pausar video del servicio' : 'Reproducir video del servicio')} onClick={() => setPlaying(value => !value)}>{playing ? <Pause size={18}/> : <Play size={18}/>}</button>}
  </figure>;
}
